module.exports = __webpack_public_path__ + "img/mobile-menu.4735c29a.svg";